// extracted by mini-css-extract-plugin
export default {"modal":"modal__KLCf2","icon":"icon__xwaOl"};